// extracted by mini-css-extract-plugin
export default {"moreLink":"MoreLink_moreLink__zLqUE","chevron":"MoreLink_chevron__sBB+N","skeletonLoadingAnimation":"MoreLink_skeletonLoadingAnimation__mJ4MU"};